import { BookOpen, Linkedin, MessageCircle, Send, Twitter, Zap } from 'lucide-react';
import { OrderlyLogo } from './orderly/OrderlyLogo';

const footerSections = [
  {
    title: 'Developers',
    links: [
      { label: 'Documentation', href: 'https://orderly.network/docs/getting-started/what-is-orderly-network' },
      { label: 'GitHub', href: 'https://github.com/OrderlyNetwork' },
      { label: 'CLI', href: 'https://github.com/OrderlyNetwork/cli' },
      { label: 'Orderly SDKs', href: 'https://orderly.network/docs/sdks/overview' },
    ],
  },
  {
    title: 'Traders',
    links: [
      { label: 'Trade on DEXs', href: 'https://orderly.network/docs/introduction/trade-on-orderly/builders' },
      { label: 'Orderly Explorer', href: 'https://explorer.orderly.network/' },
      { label: 'Orderly Dashboard', href: 'https://dashboard.orderly.network/' },
      { label: 'API Docs', href: 'https://orderly.network/docs/build-on-evm/evm-api/introduction' },
    ],
  },
  {
    title: 'Ecosystem',
    links: [
      { label: 'Partners', href: 'https://orderly.network/partners' },
      { label: 'Blog', href: 'https://orderly.network/blog' },
      { label: 'Listing', href: 'https://orderly.network/listing' },
    ],
  },
  {
    title: 'About',
    links: [
      { label: 'Team', href: 'https://orderly.network/team' },
      { label: 'Dune Dashboard', href: 'https://dune.com/orderly_network/orderly-dashboard' },
      { label: 'Press Kit', href: 'https://live.standards.site/orderly-brandguidelines' },
      { label: 'Careers', href: 'https://job-boards.greenhouse.io/orderly' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', href: 'https://orderly.network/docs/introduction/privacy-policy' },
      { label: 'Terms of Service', href: 'https://orderly.network/docs/introduction/terms-of-service' },
      { label: 'Builder Guidelines', href: 'https://orderly.network/docs/introduction/orderly-one/builder-guidelines' },
      { label: 'Supplemental Terms for DEXs', href: 'https://orderly.network/docs/introduction/orderly-one/supplemental-terms-for-dexes' },
    ],
  },
];

const socialLinks = [
  { label: 'Snapshot', href: 'https://snapshot.box/#/s:orderlygov.eth', Icon: Zap },
  { label: 'Discord', href: 'https://discord.com/invite/orderlynetwork', Icon: MessageCircle },
  { label: 'Telegram', href: 'https://t.me/Orderly_Discussions', Icon: Send },
  { label: 'X', href: 'https://x.com/OrderlyNetwork', Icon: Twitter },
  { label: 'Medium', href: 'https://medium.com/@orderlynetwork', Icon: BookOpen },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/orderly-network', Icon: Linkedin },
];

export default function Footer() {
  return (
    <footer className="app-footer" aria-label="Site footer">
      <div className="app-footer-main">
        <div className="app-footer-inner">
          <div className="app-footer-logo" aria-hidden="true">
            <OrderlyLogo className="h-10 w-10" />
          </div>
          <nav className="app-footer-links" aria-label="Orderly resources">
            {footerSections.map((section) => (
              <section key={section.title} className="app-footer-section" aria-labelledby={`footer-${section.title}`}>
                <h2 id={`footer-${section.title}`}>{section.title}</h2>
                <ul>
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a href={link.href} target="_blank" rel="noreferrer">{link.label}</a>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </nav>
        </div>
      </div>
      <div className="app-footer-bottom">
        <div className="app-footer-bottom-inner">
          <span>© 2026 Orderly Network</span>
          <div className="app-footer-socials" aria-label="Orderly social links">
            {socialLinks.map(({ label, href, Icon }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}>
                <Icon aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
